import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '@mui/material';

import { Institute, AppActionTypes } from '../../redux/types';
import InstituteFormGroup from './InstituteFormGroup';
import ContentBox from '../layout/ContentBox';
import InstituteEditDialog from './InstituteEditDialog';

type Props = {
  institute: Institute;
  locale: string;
  onChange: () => Promise<void>;
  updateInstitute: (param: Institute) => Promise<Institute>;
  addInstitute: (param: Institute) => Promise<Institute>;
  showNotification: (param: string | React.ReactElement) => AppActionTypes;
}

const InstituteDetails: React.FC<Props> = ({
  institute,
  locale,
  onChange,
  showNotification,
  updateInstitute,
  addInstitute,
}: Props) => {
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [operation, setOperation] = useState('edit');

  const openDialogWithOperation = (openDialog: boolean, doOperation?: 'edit' | 'add') => {
    setEditDialogOpen(openDialog);
    if (doOperation) {
      setOperation(doOperation);
    }
  };

  return (
    <ContentBox title={<FormattedMessage id="instituteView.instituteDataHeading" />}>
      <InstituteFormGroup
        institute={institute}
        locale={locale}
      />
      {
        editDialogOpen && (
          <InstituteEditDialog
            isOpen={editDialogOpen}
            institute={institute || {}}
            updateInstitute={operation === 'edit' ? updateInstitute : addInstitute}
            showNotification={showNotification}
            onClose={(needRefresh) => {
              setEditDialogOpen(false);
              if (needRefresh) {
                onChange();
              }
            }}
            locale={locale}
            lockCountry
            disableInstituteCountry={operation === 'edit'}
          />
        )
      }
      {
        institute
          ? (
            <Button
              variant="contained"
              onClick={() => openDialogWithOperation(true, 'edit')}
              color="primary"
            >
              <FormattedMessage id="instituteView.editInstitute" />
            </Button>
          )
          : (
            <Button
              variant="contained"
              color="primary"
              onClick={() => openDialogWithOperation(true, 'add')}
            >
              <FormattedMessage id="instituteView.registerNewInstitute" />
            </Button>
          )
      }
    </ContentBox>
  );
};

export default InstituteDetails;
